import { Switch } from '@mui/material';

const skipSlideSwitchStyles = {
  width: 52,
  height: 32,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: '7px',
    transition: 'transform 0.2s',
    '&.Mui-checked': {
      transform: 'translateX(20px)',
      '& + .MuiSwitch-track': {
        backgroundColor: '#2F736E',
        opacity: 1,
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: '#fff',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 18,
    height: 18,
    backgroundColor: '#2F736E',
    boxShadow: 'none',
  },
  '& .MuiSwitch-track': {
    borderRadius: 14,
    backgroundColor: '#E8EAEB',
    border: '2px solid #2F736E',
    opacity: 1,
  },
  '& .Mui-disabled': {
    '& .MuiSwitch-thumb': {
      backgroundColor: '#A0B8B6',
    },
    '&.Mui-checked .MuiSwitch-thumb': {
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
    },
    '& + .MuiSwitch-track': {
      backgroundColor: '#E8EAEB',
      border: '2px solid #A0B8B6',
      opacity: '1 !important',
    },
    '&.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#A0B8B6',
      border: '2px solid #A0B8B6',
      opacity: '1 !important',
    },
  },
};
const recoupToggleStyles = {
  ...skipSlideSwitchStyles,

  width: 36,
  height: 19,

  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: '4px',
    transition: 'transform 0.2s',

    '&.Mui-checked': {
      transform: 'translateX(17px)',

      '& + .MuiSwitch-track': {
        backgroundColor: '#2F736E',
        opacity: 1,
      },

      '& .MuiSwitch-thumb': {
        backgroundColor: '#fff',
      },
    },
  },

  '& .MuiSwitch-thumb': {
    width: 11,
    height: 11,
    backgroundColor: '#2F736E',
    boxShadow: 'none',
  },

  '& .MuiSwitch-track': {
    borderRadius: 10,
    backgroundColor: '#E8EAEB',
    border: '2px solid #2F736E',
    opacity: 1,
  },
};
const Toggle = ({
  checked,
  onChange,
  disabled,
  inverted = false,
  variant = 'skipSlide',
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled: boolean;
  inverted?: boolean;
  variant?: 'skipSlide' | 'recoup';
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = inverted ? !event.target.checked : event.target.checked;
    onChange(value);
  };

  return (
    <Switch
      disableRipple
      checked={inverted ? !checked : checked}
      onChange={handleChange}
      disabled={disabled}
      sx={variant === 'skipSlide' ? skipSlideSwitchStyles : recoupToggleStyles}
    />
  );
};

export default Toggle;
